import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SectionHeader from './SectionHeader';
import { Reveal } from './ScrollReveal';
import { FiPlus } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const AccordionItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border-b border-brand-border last:border-b-0">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center py-7 px-10 text-[1.1rem] font-serif text-brand-white hover:text-brand-gold transition-colors text-left"
      >
        {question}
        <motion.div 
          animate={{ rotate: isOpen ? 45 : 0 }}
          className="text-brand-gold text-xl ml-6"
        >
          <SafeIcon icon={FiPlus} />
        </motion.div>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden bg-brand-surface/30"
          >
            <div className="px-10 pb-10 pt-2 text-[1rem] text-brand-muted leading-relaxed font-light" dangerouslySetInnerHTML={{ __html: answer }} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default function CaseStudies() {
  const cases = [
    {
      meta: "GF · Produktion",
      quote: "„Ich hatte keinen, dem ich wirklich sagen konnte, was intern nicht funktioniert.\"",
      res: "Unternehmensbewertung +40 % nach 12 Monaten."
    },
    {
      meta: "Gründer · SaaS",
      quote: "„Der erste Ort, wo ich offen über Probleme sprechen konnte — ohne Angst.\"",
      res: "Team skaliert & Series-A erfolgreich abgeschlossen."
    },
    {
      meta: "Solopreneur",
      quote: "„Zum ersten Mal Menschen, die meine Situation wirklich verstehen.\"",
      res: "Umsatz verdoppelt & erste Mitarbeiterin eingestellt."
    }
  ];

  return (
    <section id="ergebnisse" className="py-32 relative z-10 border-t border-brand-border">
      <div className="max-w-[1100px] mx-auto px-8">
        <SectionHeader 
          num="07" 
          eyebrow="Aus der Praxis" 
          title="Echte Gespräche.<br/><em class='not-italic italic text-brand-gold'>Echte Ergebnisse.</em>" 
        />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
          {cases.map((c, idx) => (
            <Reveal key={idx} delay={idx * 0.1}>
              <div className="bg-brand-surface border border-brand-border p-10 h-full">
                <div className="text-[0.7rem] font-bold tracking-[0.2em] uppercase text-brand-gold mb-6">{c.meta}</div>
                <div className="font-serif text-[1.2rem] italic text-brand-white leading-relaxed mb-6">{c.quote}</div>
                <div className="text-[0.9rem] text-brand-muted font-medium border-t border-brand-border pt-6">
                  {c.res}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <div className="max-w-[800px] mx-auto border border-brand-border">
            { [
              { q: "Was kostet das Executive Sparring konkret?", a: "Der Einstieg ist ein <strong>kostenloses Probe-Board-Meeting</strong>. Die Partnerschaft kostet <strong>€ 1.500 pro Monat</strong>." },
              { q: "Wie funktioniert die Garantie genau?", a: "Ich garantiere die Verdoppelung Ihres Unternehmenswertes in <strong>maximal 36 Monaten</strong>. Sonst arbeite ich kostenlos weiter." }
            ].map((faq, idx) => (
              <AccordionItem key={idx} question={faq.q} answer={faq.a} />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}